// Translation for en
export const my = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'ချတ်ဝန်ဆောင်မှု ယခုအချိန်တွင် မရရှိနိုင်ပါ။ နောက်မှ ထပ်မံကြိုးစားပါ။'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'သင်ရိုးညွှန်းတမ်း',
                buttonTitle: 'သင်ရိုးညွှန်းတမ်းအကြောင်းအရာကိုပြပါ',
                modalTitle: '{app} သင်ရိုးညွှန်းတမ်း',
                sections: {
                    topic: 'သင်ရိုးညွှန်းတမ်းအကြောင်းအရာ',
                    explanation: 'ကလေးများအတွက်ရှင်းလင်းချက်',
                    studentProfile: 'ကျောင်းသားကိုယ်ရေးအချက်အလက်'
                },
                topic: {
                    empty: 'ဤမိုက်ခရိုအက်ပ်နှင့်ချိတ်ဆက်ထားသောသင်ရိုးညွှန်းတမ်းအကြောင်းအရာမရှိပါ။',
                    missingDetail: 'ဤမိုက်ခရိုအက်ပ်အတွက်အသေးစိတ်သင်ရိုးညွှန်းတမ်းဒေတာကိုနောက်ခံတွင်မရရှိနိုင်သေးပါ။',
                    learningGoals: 'သင်ယူမှုရည်မှန်းချက်များ',
                    prerequisites: 'ကြိုတင်လိုအပ်ချက်များ',
                    unitLabel: 'ယူနစ်',
                    durationLabel: 'ကြာချိန်',
                    difficultyLabel: 'အခက်အခဲအဆင့်',
                    hours: 'နာရီ',
                    minutes: 'မိနစ်'
                },
                explanation: {
                    empty: 'ကလေးများအတွက်ရှင်းလင်းချက်မရရှိနိုင်ပါ။',
                    loadingPrepare: 'AI ကရှင်းလင်းချက်ကိုပြင်ဆင်နေသည်',
                    loadingExplain: 'AI ကအကြောင်းအရာကိုကလေးများနားလည်လွယ်သောဘာသာစကားဖြင့်ရှင်းပြနေသည်',
                    requestFailed: 'ကလေးများအတွက်ရှင်းလင်းချက်ကိုမထုတ်လုပ်နိုင်ပါ။'
                },
                studentProfile: {
                    country: 'နိုင်ငံ',
                    region: 'ပြည်နယ် / တိုင်းဒေသကြီး',
                    schoolType: 'ကျောင်းအမျိုးအစား',
                    grade: 'အတန်း',
                    noContext: 'ကျောင်းသားအခြေအနေမရရှိနိုင်ပါ။',
                    childProfileNotFound: 'လက်ရှိအကောင့်ဝင်ထားသူအတွက်နောက်ခံတွင်ကျောင်းသားကိုယ်ရေးအချက်အလက်မတွေ့ရှိပါ။',
                    loginProfileIncomplete: 'အကောင့်ဝင်ထားသူ၏ကိုယ်ရေးအချက်အလက်တွင်ကျောင်းသားအခြေအနေအပြည့်အစုံမပါဝင်သေးပါ။',
                    educationContextNotFound: 'ကျောင်းသားကိုယ်ရေးအချက်အလက်တွေ့ရှိသော်လည်းသင်ရိုးညွှန်းတမ်းသတ်မှတ်ချက်မရှိပါ။',
                    noToken: 'အကောင့်ဝင်ထားသောကျောင်းသားမတွေ့ရှိပါ။'
                },
                errors: {
                    signInRequired: 'သင်ရိုးညွှန်းတမ်းကိုကြည့်ရှုရန်ကျေးဇူးပြု၍အကောင့်ဝင်ပါ။',
                    appIdMissing: 'အက်ပ် ID ပျောက်ဆုံးနေသည်။',
                    loadFailed: 'သင်ရိုးညွှန်းတမ်းဒေတာကိုမဖွင့်နိုင်ပါ။'
                }
            }
    };
